export type UserDialogMessages = {
  // Dialog Messages
  deleteUserDialogTitle: string;
  deleteUserDialogContent: string;
  deleteUserDialogCancel: string;
  deleteUserDialogConfirm: string;
};

export const USER_DIALOG_MESSAGES: UserDialogMessages = {
  deleteUserDialogTitle: "Excluir Usuário",
  deleteUserDialogContent: "Tem certeza de que deseja excluir este usuário?",
  deleteUserDialogCancel: "Sair",
  deleteUserDialogConfirm: "Confirmar",
};
